import { Component } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';

@Component({
  selector: 'user-info',
  templateUrl: './user-info.component.html',
  styleUrls: ['./user-info.component.scss']
})
export class UserInfoComponent {
  constructor(
    public dialog: MatDialog,
    private router: Router
  ) { }

  openPDF(url: string, event: Event) {
    event.preventDefault();
    this.router.navigate(['/cabinet/pdf'], { queryParams: { url } });
  }
}
